module.exports = __webpack_public_path__ + "static/media/angle-arrow-down-primary.51295a10.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/angle-arrow-down-primary.svg
// module id = 84
// module chunks = 0